import React, { useState, useContext, useCallback } from 'react';
import MenuBar from './MenuBar.jsx';
// import { BubbleMenu, FloatingMenu } from '@tiptap/react/menus'
import { useEditor, EditorContent } from '@tiptap/react';
import { upload_json_as_file, save_tiptap_doc } from '../../../../services/projectservice.js';
import { AuthContext } from '../../../../AuthContext.jsx';
import { tt_extensions } from './TTTemplate.jsx';
import UploadModal from './UploadModal.jsx';
import './tiptap_editor.scss'
import './tiptap.scss' 


const TipTapEditor = ({ initialContent, doc_id }) => {

  const { authToken, claims, isLoading, onLogout } = useContext(AuthContext);

  const editor = useEditor({
    extensions: tt_extensions,
    content: initialContent,
    onUpdate: ({ editor }) => { 
      console.log(editor.getHTML());
    },
  });

  const [savedData, setSavedData] = React.useState({});
  const [editorError, setEditorError] = React.useState('');

  const handleSave = (data) => {
    setEditorError('');
    setSavedData(data);
  }

  const handleSaveError = (error) => {
    console.error("Error saving data:", error);
    setEditorError(`Error saving data `);
  }

  const saveChanges = () => {
    const dataToSave = editor.getJSON();
     console.log("Data to save:", dataToSave);
     save_tiptap_doc(doc_id, 'Demo Content Doc', dataToSave,  ['test-label'], true, true, [ ], 'demo_docs', authToken, handleSave, handleSaveError)
  }

  const insertImage = useCallback(() => {
    setShowModal(true);
    // // const url = window.prompt('URL') 
    // if (url) {
    //   console.log("Inserting image with URL:", url);
    //   editor.chain().focus().setImage({ src: url }).run()
    // }  
  }, [editor])

 const [showModal, setShowModal] = useState(false);
   
 const handleCancelImg = () => { 
      setShowModal(false); 
  } 
  
  const handleChooseImg = (url) => {
      setShowModal(false);
      console.log("Inserting image with URL:", url);
      editor.chain().focus().setImage({ src: url }).run()
      // handleComplete(url);

  }       


  // docs: https://tiptap.dev/docs/editor/extensions/nodes/heading
 
  return (
    <>
      {editorError && <div style={{ color: 'red' }}>{editorError}</div>}
      <MenuBar editor={editor}
        handleInsertImage={insertImage} 
        handleSave={saveChanges} />
      <UploadModal show={showModal} handleSave={handleChooseImg} handleCancel={handleCancelImg}  /> 
      <EditorContent editor={editor} 
        style={{ border: '1px solid #ccc', padding: '10px', minHeight: '200px' }} /> 
       <div>
        <h3>Saved Data:</h3>
        {savedData && <div><pre>{JSON.stringify(savedData, null, 2)}</pre></div>} 
      </div>
    </>
  );
};

export default TipTapEditor;